import React from 'react'
import PasarelaPagosData from '../../components/Admin/PasarelaPagosData/PasarelaPagosData'
import Header from '../Header/Header'
import HeaderDash from '../../components/Admin/HeaderDash/HeaderDash'
export default function PasarelaPagos() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <PasarelaPagosData />
                </div>
            </section>
        </div>
    )
}

